(() => {
  'use strict';
  const scope = 'kaching-bundle[product-id="15373723402431"] .kaching-bundles__block[data-deal-block-id="406835b2-601d-4ac1-8820-e2db64f2dd6f"] .kaching-bundles__bar[data-deal-bar-id="MLsa"]';
  const wanted = ["🏠 Santa's House","🐦 Cardinal","🌲 Forest Cabin","🚂 Vintage Train","❄️ Ice Castle","🍪 Gingerbread House","🎅 Flying Santa"];
  let timer;
  function sync() {
    clearTimeout(timer);
    const bar = document.querySelector(scope);
    if (!bar || !bar.classList.contains('kaching-bundles__bar--selected')) return;
    const selectors = [...bar.querySelectorAll('select.kaching-bundles__bar-variant-select[data-name="style"]')];
    if (selectors.length !== 7) return;
    const index = selectors.findIndex((select, i) => select.value !== wanted[i]);
    if (index !== -1) {
      const select = selectors[index];
      if (![...select.options].some(option => option.value === wanted[index])) return;
      select.value = wanted[index];
      select.dispatchEvent(new Event('change', {bubbles:true}));
      timer = setTimeout(sync, 80);
      return;
    }
    bar.querySelector('[data-christmas-sync-status]')?.remove();
    const choices = bar.querySelector('.kaching-bundles__bar-variants');
    if (choices) { choices.hidden = true; choices.style.setProperty('display', 'none', 'important'); }

  }
  const observer = new MutationObserver(() => { clearTimeout(timer); timer = setTimeout(sync, 40); });
  observer.observe(document.body, {childList:true, subtree:true, attributes:true, attributeFilter:['class']});
  document.addEventListener('change', event => { if (event.target.closest(scope)) {clearTimeout(timer);timer=setTimeout(sync,40);} });
  function isReady() {
    const bar = document.querySelector(scope);
    if (!bar || !bar.classList.contains('kaching-bundles__bar--selected')) return true;
    const selects = [...bar.querySelectorAll('select.kaching-bundles__bar-variant-select[data-name="style"]')];
    return selects.length === 7 && selects.every((select, i) => select.value === wanted[i]);
  }
  function guard(event) {
    if (isReady()) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const bar = document.querySelector(scope);
    if (bar && !bar.querySelector('[data-christmas-sync-status]')) {
      const status = document.createElement('p');
      status.dataset.christmasSyncStatus = 'true';
      status.setAttribute('role', 'status');
      status.textContent = 'Preparing all 7 designs. Please wait a moment, then add the collection to your cart.';
      bar.append(status);
    }
    sync();
  }
  document.addEventListener('submit', event => {
    if (event.target.matches('form[action*="/cart/add"]')) guard(event);
  }, true);
  document.addEventListener('click', event => {
    if (event.target.closest('button[name="add"], input[name="add"], [id^="ProductSubmitButton"], [id^="SectionAtcBtn"], #yx_checkout, #yx_paypal_checkout, .shopify-payment-button, shopify-accelerated-checkout')) guard(event);
  }, true);
  sync();
})();
/* Local candidate: disable this product's native buttons while its fixed collection prepares. */
(() => {
  'use strict';
  const cfg = {"productId": "15373723402431", "dealId": "406835b2-601d-4ac1-8820-e2db64f2dd6f", "fixedId": "MLsa", "dimension": "style", "wanted": ["🏠 Santa's House", "🐦 Cardinal", "🌲 Forest Cabin", "🚂 Vintage Train", "❄️ Ice Castle", "🍪 Gingerbread House", "🎅 Flying Santa"]};
  const owner = 'fixed-collection-' + cfg.productId;
  const rootSelector = 'kaching-bundle[product-id="'+cfg.productId+'"] .kaching-bundles__block[data-deal-block-id="'+cfg.dealId+'"],kaching-bundles-block[deal-block-id="'+cfg.dealId+'"]';
  const nativeButtons = 'button[name="add"],button[id*="ProductSubmitButton"],button[id^="SectionAtcBtn"],button#yx_checkout,button#yx_paypal_checkout,button#yx_kl_checkout';
  const locked = new Map(), formIds = new WeakMap();
  let nextFormId=0, pending=false, desiredFixed=null, pollTimer=null, generation=0, attempts=0, acceptedKey='';
  function root(){ return document.querySelector(rootSelector); }
  function section(){ return root()?.closest('.shopify-section') || null; }
  function fixed(){return root()?.querySelector('.kaching-bundles__bar[data-deal-bar-id="'+cfg.fixedId+'"]');}
  function isFixedSelected(){const b=fixed();return !!b?.querySelector('input[type="radio"]')?.checked && b.classList.contains('kaching-bundles__bar--selected');}
  function telemetry(state,reason){const b=root();if(!b)return;b.dataset.collectionLockState=state;b.dataset.collectionLockReason=reason;}
  function disableOwnedButtons(){
    const s=section();if(!s)return;
    for(const button of s.querySelectorAll(nativeButtons)){
      if(!(button instanceof HTMLButtonElement))continue;
      if(locked.has(button)){if(button.dataset.collectionLockOwner===owner && !button.disabled)button.disabled=true;continue;}
      if(button.disabled)continue; // Never take ownership of an already-disabled control.
      locked.set(button,{disabled:button.disabled});
      button.dataset.collectionLockOwner=owner;
      button.disabled=true;
    }
  }
  function restoreOwnedButtons(){
    for(const [button,prior] of locked){
      if(button.dataset.collectionLockOwner!==owner)continue;
      button.disabled=prior.disabled;
      delete button.dataset.collectionLockOwner;
    }
    locked.clear();
  }
  function release(reason){generation++;pending=false;clearTimeout(pollTimer);pollTimer=null;restoreOwnedButtons();telemetry('released',reason);}
  function sample(){
    const b=fixed(),s=section();
    if(!b||!s||!isFixedSelected())return {ready:false,key:'waiting-for-fixed-selection'};
    const values=[...b.querySelectorAll('select.kaching-bundles__bar-variant-select')].filter(x=>x.dataset.name===cfg.dimension).map(x=>x.value);
    if(values.length!==cfg.wanted.length || values.some((v,i)=>v!==cfg.wanted[i]))return {ready:false,key:'waiting-for-unique-designs'};
    const add=s.querySelector('button[id*="ProductSubmitButton"]') || s.querySelector('button[name="add"]');
    const form=add?.form || s.querySelector('form[action*="/cart/add"]');
    if(!form?.isConnected)return {ready:false,key:'waiting-for-current-form'};
    const quantities=new FormData(form).getAll('quantity').map(String);
    if(quantities.length!==1 || Number(quantities[0])!==cfg.wanted.length)return {ready:false,key:'waiting-for-collection-quantity'};
    if(!formIds.has(form))formIds.set(form,++nextFormId);
    return {ready:true,key:JSON.stringify([formIds.get(form),values,quantities])};
  }
  function schedulePoll(delay=200){clearTimeout(pollTimer);if(pending&&attempts<30)pollTimer=setTimeout(check,delay);}
  function check(){
    pollTimer=null;if(!pending||desiredFixed!==true)return;
    disableOwnedButtons();
    const state=sample();attempts++;
    if(!state.ready){telemetry('pending',state.key);schedulePoll();return;}
    const mine=generation;
    requestAnimationFrame(()=>{
      if(!pending||generation!==mine)return;
      const first=sample();
      if(!first.ready||first.key!==state.key){schedulePoll();return;}
      requestAnimationFrame(()=>{
        if(!pending||generation!==mine)return;
        const second=sample();
        if(!second.ready||second.key!==first.key){schedulePoll();return;}
        acceptedKey=second.key;
        release('fixed-designs-and-quantity-stable-two-frames');
      });
    });
  }
  function begin(){
    desiredFixed=true;pending=true;generation++;attempts=0;acceptedKey='';
    disableOwnedButtons();telemetry('pending','preparing-fixed-collection');schedulePoll(0);
  }
  window.addEventListener('click',event=>{
    const bar=event.target.closest?.('.kaching-bundles__bar');
    if(!bar||!root()?.contains(bar))return;
    if(bar.dataset.dealBarId===cfg.fixedId){
      const now=sample();
      if(!isFixedSelected() || !now.ready || now.key!==acceptedKey)begin();
    }else{
      desiredFixed=false;acceptedKey='';release('non-fixed-offer-selected');
    }
  },true);
  const observeRoot=document.querySelector('main');
  if(observeRoot)new MutationObserver(records=>{
    const s=section();
    const relevant=records.some(r=>s?.contains(r.target) || [...r.addedNodes,...r.removedNodes].some(n=>n.nodeType===1&&(n.matches?.(rootSelector)||n.querySelector?.(rootSelector))));
    if(!relevant)return;
    if(desiredFixed===null && isFixedSelected())begin();
    if(desiredFixed!==true)return;
    if(pending){disableOwnedButtons();if(!pollTimer && attempts<30)schedulePoll(0);return;}
    // Once released, native submit may mutate its form. Do not relock during submission.
    // Only entering the fixed offer starts a new preparation generation.
  }).observe(observeRoot,{childList:true,subtree:true,attributes:true,attributeFilter:['class','checked','value']});
  if(isFixedSelected())begin();
})();
